import SectionHeading from '@/components/base/SectionHeading';
import { siteBrand } from '@/mocks/siteData';

const facts = [
  { label: '起始时间', value: '2019 年' },
  { label: '公开议题', value: '386 期' },
  { label: '协作媒体与研究机构', value: '40+' },
];

export default function AboutIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20wide%20shot%20of%20a%20quiet%20newspaper%20archive%20room%20with%20tall%20shelves%20of%20bound%20volumes%2C%20warm%20afternoon%20light%20through%20a%20tall%20window%2C%20muted%20warm%20tones%2C%20editorial%20documentary%20mood%2C%20no%20people%2C%20no%20text&width=1100&height=825&seq=st-about-archive-2026&orientation=landscape"
                alt="安静的报刊档案室，书架上整齐排列着合订本"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-6">
            <SectionHeading
              kicker="About Us"
              title="从一封匿名邮件，到一个认真对待信息的团队"
              description={siteBrand.intro}
            />
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
              我们相信，很多重要的事实并不是不存在，而是没有被整理。平台做的最多的工作，
              是把散落在不同人手上的片段对齐：时间、地点、涉及主体与可验证的依据。
              这项工作缓慢、琐碎，也很少被看见，但它决定了后续所有判断是否站得住。
            </p>

            <dl className="mt-9 grid grid-cols-3 gap-5 border-t border-foreground-950/10 pt-7">
              {facts.map((fact) => (
                <div key={fact.label}>
                  <dt className="font-heading text-xl md:text-2xl font-bold text-primary-600">
                    {fact.value}
                  </dt>
                  <dd className="mt-2 font-mono text-[11px] md:text-xs text-foreground-500 leading-relaxed">
                    {fact.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}